var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import { FieldTitle, useInput } from 'ra-core';
import { makeStyles } from '@material-ui/core/styles';
import { InputHelperText, InputPropTypes } from 'react-admin';
import { isValidElement } from 'react';
const ToggleSwitchInput = (_a) => {
    var { format, label, fullWidth, helperText, onBlur, onChange, onFocus, options, disabled, parse, resource, source, validate } = _a, rest = __rest(_a, ["format", "label", "fullWidth", "helperText", "onBlur", "onChange", "onFocus", "options", "disabled", "parse", "resource", "source", "validate"]);
    const _b = useInput(Object.assign({ format,
        onBlur,
        onChange,
        onFocus,
        parse,
        resource,
        source, type: 'checkbox', validate }, rest)), { id } = _b, _c = _b.input, { onChange: finalFormOnChange, type, value } = _c, inputProps = __rest(_c, ["onChange", "type", "value"]), { isRequired, meta: { error, touched } } = _b;
    const classes = useStyles();
    const handleChange = useCallback((event, value) => {
        finalFormOnChange(value);
    }, [finalFormOnChange]);
    return (React.createElement(FormGroup, Object.assign({}, rest),
        React.createElement(FormControlLabel, { control: React.createElement(Switch, Object.assign({ id: id, color: "primary", onChange: handleChange }, inputProps, options, { disabled: disabled, className: classes.checkbox })), label: isValidElement(label) ? (label) : (React.createElement(FieldTitle, { label: label, source: source, resource: resource, isRequired: isRequired })) }),
        React.createElement(FormHelperText, { error: !!error },
            React.createElement(InputHelperText, { touched: touched, error: error, helperText: helperText }))));
};
ToggleSwitchInput.propTypes = Object.assign(Object.assign({}, InputPropTypes), { label: PropTypes.any, options: PropTypes.shape(Switch.propTypes), disabled: PropTypes.bool });
ToggleSwitchInput.defaultProps = {
    options: {},
};
export default ToggleSwitchInput;
const useStyles = makeStyles({
    checkbox: {
        alignSelf: 'center',
        paddingTop: '2',
    },
});
//# sourceMappingURL=ToggleSwitchInput.js.map